module.exports = __webpack_public_path__ + "static/media/mobile-design.cff02ec3.png";